/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconMoreHoriz/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconMoreHoriz({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconMoreHoriz",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconMoreHoriz.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z13vBr1': alignSelf,'--mt-2-Z13vBr1': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z13vBr1': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z13vBr1': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z13vBr1': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z13vBr1': opacity,'--w-10-Z13vBr1': typeof width === 'number' ? `${width}px` : width,'--h-11-Z13vBr1': typeof height === 'number' ? `${height}px` : height,'--a-7-Z13vBr1': isAnimated ? animation : "none",'--sd-8-Z13vBr1': isAnimated ? strokeDashoffset : 0,'--sd-9-Z13vBr1': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconMoreHoriz.SvgPath"
  data-view-path={viewPath}
 d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
 style={{'--f-12-Z13vBr1': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}